import { settings } from '@pixi/settings';

/**
 * Default `canvasPadding` for canvas-based Mesh rendering.
 *
 * @see PIXI.Mesh2d#canvasPadding
 * @static
 * @name MESH_CANVAS_PADDING
 * @memberof PIXI.settings
 * @type {number}
 * @default 0
 */
settings.MESH_CANVAS_PADDING = 0;

export { settings };
